import { setFontVariant, colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const StyledCrmIntegratedTitle = styled.h3`
    ${setFontVariant("subtitle1", colorsPalettes.carbon["500"])}
    line-height: 19px;
    margin: 0 0 8px;
`;

export const StyledInactiveCrmIntegration = styled.div`
    align-items: center;
    display: flex;
`;

export const StyledImageContainer = styled.div`
    height: 174px;
    width: 174px;
    margin-right: 40px;
    margin-top: -24px;

    img {
        width: 164px;
    }
`;
